export const categories = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    image: 'https://readdy.ai/api/search-image?query=Two%20pairs%20of%20modern%20sneakers%20on%20warm%20cream%20textured%20fabric%20surface%2C%20one%20casual%20white%20leather%20sneaker%20and%20one%20stylish%20running%20shoe%2C%20soft%20natural%20window%20light%20from%20left%20side%2C%20clean%20minimalist%20product%20photography%2C%20warm%20beige%20cream%20and%20muted%20terracotta%20palette%2C%20gentle%20shadows%2C%20editorial%20footwear%20display&width=400&height=300&seq=cat-shoes-2026&orientation=landscape',
  },
  {
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20oversized%20cotton%20hoodie%20in%20warm%20sand%20beige%20color%20folded%20neatly%20on%20cream%20textured%20linen%20surface%2C%20soft%20natural%20window%20light%20casting%20gentle%20folds%2C%20minimalist%20streetwear%20product%20photography%2C%20warm%20neutral%20earth%20tones%2C%20calm%20comfortable%20aesthetic%20with%20subtle%20texture%20details&width=400&height=300&seq=cat-hoodies-2026&orientation=landscape',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Premium%20heavyweight%20cotton%20t-shirt%20in%20muted%20olive%20green%20folded%20flat%20on%20warm%20cream%20textured%20surface%2C%20soft%20natural%20daylight%2C%20clean%20minimalist%20product%20photography%2C%20subtle%20fabric%20texture%20visible%2C%20warm%20earthy%20neutral%20palette%2C%20modern%20casual%20aesthetic&width=400&height=300&seq=cat-tshirts-2026&orientation=landscape',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-cloudy-line',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20bomber%20jacket%20in%20warm%20caramel%20brown%20tone%20draped%20elegantly%20on%20cream%20textured%20background%2C%20soft%20natural%20window%20light%2C%20minimalist%20editorial%20fashion%20photography%2C%20warm%20earthy%20palette%2C%20gentle%20fabric%20folds%2C%20sophisticated%20casual%20outerwear%20aesthetic&width=400&height=300&seq=cat-jackets-2026&orientation=landscape',
  },
  {
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
    image: 'https://readdy.ai/api/search-image?query=Modern%20casual%20chino%20pants%20in%20warm%20sand%20beige%20color%20neatly%20folded%20on%20cream%20textured%20linen%2C%20soft%20natural%20light%20from%20window%2C%20minimalist%20product%20photography%2C%20clean%20fabric%20folds%2C%20warm%20neutral%20palette%2C%20contemporary%20everyday%20wear%20aesthetic&width=400&height=300&seq=cat-pants-2026&orientation=landscape',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-customer-service-line',
    image: 'https://readdy.ai/api/search-image?query=Two%20stylish%20baseball%20caps%20in%20muted%20cream%20and%20warm%20terracotta%20colors%20arranged%20on%20textured%20beige%20surface%2C%20soft%20natural%20window%20light%2C%20clean%20minimalist%20product%20flatlay%2C%20warm%20earthy%20neutral%20palette%2C%20modern%20casual%20accessories%20photography&width=400&height=300&seq=cat-headwear-2026&orientation=landscape',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    image: 'https://readdy.ai/api/search-image?query=Coordinated%20matching%20outfit%20set%20with%20hoodie%20and%20joggers%20in%20warm%20oatmeal%20beige%20folded%20together%20on%20cream%20textured%20surface%2C%20soft%20natural%20daylight%2C%20minimalist%20fashion%20product%20photography%2C%20warm%20neutral%20palette%2C%20harmonious%20coordinated%20aesthetic&width=400&height=300&seq=cat-sets-2026&orientation=landscape',
  },
  {
    name: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-user-line',
    image: 'https://readdy.ai/api/search-image?query=Soft%20cotton%20underwear%20essentials%20in%20neutral%20cream%20and%20warm%20beige%20tones%20neatly%20arranged%20on%20textured%20linen%20surface%2C%20soft%20diffused%20natural%20lighting%2C%20discreet%20minimalist%20product%20photography%2C%20warm%20earthy%20palette%2C%20clean%20simple%20aesthetic&width=400&height=300&seq=cat-underwear-2026&orientation=landscape',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-basketball-line',
    image: 'https://readdy.ai/api/search-image?query=Sports%20jersey%20in%20deep%20forest%20green%20with%20subtle%20team-inspired%20design%20laid%20flat%20on%20warm%20cream%20surface%2C%20soft%20natural%20window%20light%2C%20minimalist%20sports%20apparel%20photography%2C%20warm%20earthy%20green%20and%20beige%20palette%2C%20athletic%20casual%20aesthetic&width=400&height=300&seq=cat-jersey-2026&orientation=landscape',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20fashion%20accessories%20including%20sunglasses%20necklace%20and%20watch%20arranged%20on%20warm%20cream%20marble%20surface%20with%20dried%20flower%20sprig%2C%20soft%20natural%20window%20light%2C%20sophisticated%20minimalist%20flatlay%20photography%2C%20warm%20beige%20gold%20and%20cream%20palette%2C%20aspirational%20lifestyle%20aesthetic&width=400&height=300&seq=cat-accessories-2026&orientation=landscape',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-handbag-line',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20minimalist%20tote%20bag%20in%20warm%20caramel%20leather%20tone%20on%20cream%20textured%20surface%2C%20soft%20natural%20window%20light%2C%20elegant%20product%20photography%2C%20warm%20neutral%20earth%20tones%2C%20gentle%20shadows%2C%20sophisticated%20everyday%20bag%20aesthetic&width=400&height=300&seq=cat-bags-2026&orientation=landscape',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20leather%20belt%20in%20warm%20cognac%20brown%20tone%20coiled%20gracefully%20on%20cream%20textured%20surface%2C%20soft%20natural%20window%20light%2C%20sophisticated%20minimalist%20product%20photography%2C%20warm%20earthy%20brown%20and%20beige%20palette%2C%20refined%20accessory%20aesthetic&width=400&height=300&seq=cat-belts-2026&orientation=landscape',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottle%20with%20warm%20amber%20fragrance%20on%20cream%20textured%20surface%20with%20delicate%20dried%20flowers%2C%20soft%20natural%20window%20light%20creating%20gentle%20reflections%2C%20sophisticated%20minimalist%20product%20photography%2C%20warm%20golden%20beige%20palette%2C%20luxurious%20sensorial%20aesthetic&width=400&height=300&seq=cat-perfumes-2026&orientation=landscape',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    image: 'https://readdy.ai/api/search-image?query=Miscellaneous%20trendy%20lifestyle%20items%20including%20keychain%20socks%20and%20small%20accessories%20arranged%20on%20warm%20cream%20textured%20surface%2C%20soft%20natural%20window%20light%2C%20eclectic%20minimalist%20flatlay%20photography%2C%20warm%20earthy%20neutral%20palette%2C%20curated%20collection%20aesthetic&width=400&height=300&seq=cat-other-2026&orientation=landscape',
  },
];

export const features = [
  {
    title: 'Fast Product Discovery',
    description: 'Find trending products without wasting hours manually searching through endless listings. Our curated database saves you valuable time.',
    icon: 'ri-flashlight-line',
  },
  {
    title: 'Organized Categories',
    description: 'Browse products by type, price range, and popularity. Every item is neatly categorized for effortless navigation.',
    icon: 'ri-layout-grid-line',
  },
  {
    title: 'QC Information',
    description: 'Understand product quality before purchasing with detailed QC reference data and inspection insights.',
    icon: 'ri-shield-check-line',
  },
  {
    title: 'Money Saving',
    description: 'Compare products across vendors and avoid costly bad purchases with community-verified recommendations.',
    icon: 'ri-money-dollar-circle-line',
  },
  {
    title: 'Updated Regularly',
    description: 'Our spreadsheet receives frequent updates with the latest trending finds, ensuring you never miss out on popular items.',
    icon: 'ri-refresh-line',
  },
  {
    title: 'Beginner Friendly',
    description: 'New to international shopping? Our easy-to-navigate guides and organized layout make getting started a breeze.',
    icon: 'ri-user-smile-line',
  },
];